<div class="import-modal-container">
    <div class="mb-3">
        <input
            type="text"
            pInputText
            placeholder="Search account form templates"
            [(ngModel)]="searchText"
            (input)="onSearch()"
            class="w-full"
        />
    </div>

    <div class="template-list-container" *ngIf="!loading">
        <div *ngIf="filteredTemplates.length === 0" class="empty-state">
            <i class="pi pi-inbox text-4xl text-400"></i>
            <p class="text-lg text-600 m-0">
                {{ searchText ? 'No templates found matching your search' : 'No form templates available' }}
            </p>
        </div>
        <div *ngIf="filteredTemplates.length > 0" class="template-header">
            <p-checkbox
                [(ngModel)]="selectAll"
                [binary]="true"
                (onChange)="toggleSelectAll()"
                inputId="selectAllCheckbox">
            </p-checkbox>
            <label for="selectAllCheckbox" class="header-label">
                Template name
            </label>
        </div>
        <div *ngFor="let template of filteredTemplates" class="template-item">
            <p-checkbox
                [value]="template"
                [(ngModel)]="selectedTemplates"
                [inputId]="'template-' + template.templateId"
                [binary]="false">
            </p-checkbox>
            <label [for]="'template-' + template.templateId" class="template-label">
                {{ template.templateName }}
            </label>
        </div>
    </div>

    <div *ngIf="loading" class="loading-state">
        <i class="pi pi-spin pi-spinner text-3xl text-primary"></i>
    </div>
</div>

<div class="modal-footer">
    <button
        type="button"
        class="modal-btn-primary"
        (click)="import()"
        [disabled]="selectedTemplates.length === 0 || loading">
        {{ loading ? 'Importing...' : 'Import to project' }}
    </button>
</div>
